import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, UserService } from '../_services';
import { User } from '../_models';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent {

  events: string[] = [];
  opened: boolean ;
  currentuser : string[]=[]; 
  isToken = false;
  loading = false;
  isUserLoggedIn = false;
 
  cUser: User = JSON.parse(localStorage.getItem('currentUser'));
  Name: string = this.cUser?.name;
  Email: string = this.cUser?.email;
  Role: string = this.cUser?.roles;

  isCSPUser: boolean = false;
  isAdminUser: boolean = false;
  issubscription: boolean = false;


  // cUser:User =  JSON.parse(localStorage.getItem('currentUser'));
  // Name : string = this.cUser?.name;
  // Role : string = this.cUser?.roles;



  constructor( private authService: AuthenticationService,private router:Router) {
  //  let authtoken= this.authService.getJwtToken();
  // this.isToken = authtoken != null && authtoken != 'undefind' ? true : false;
    
    this.isUserLoggedIn = this.cUser == null ? false : true;

  }

/*
   ngOnInit() {
    this.loading = true;
    this.userService.getAll().pipe(first()).subscribe(users => {
        this.loading = false;
        this.users = users;
    });
}
*/
ngOnInit() {
 
  //this.loading = true;
  this.cUser = JSON.parse(localStorage.getItem('currentUser'));
  this.isCSPUser = this.cUser.roles == 'CSP' ? true : false;
  this.isAdminUser = this.cUser.roles == 'Admin' ? true : false;
  this.issubscription = this.cUser.subscriptionStatus == true ? true : false;
  this.opened=this.isUserLoggedIn ? true : false;
}
toggle(){
  this.opened = !this.opened;
}

logout() {
  let res = this.authService.logout();
  if (res) {
    //this.router.navigate(["/#login"]);
    window.location.href = '/#login';
    window.location.reload();
  }
}

}
